import { createRoute, lazyRouteComponent, redirect } from "@tanstack/react-router";
import { Route as RootRoute } from "./__root";
import { validateOrderListSearch } from "./order-list-search";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/orders/$publicId/edit",
  validateSearch: validateOrderListSearch,
  beforeLoad: ({ context }) => {
    if (context.authLoading) return;
    if (!context.session) throw redirect({ to: "/auth/login" });
  },
  component: lazyRouteComponent(() => import("./orders.edit"), "EditOrderPage"),
});
